module.exports = __webpack_public_path__ + "img/college-graduate.4c66aad5.png";